import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { usePageTitle } from '../../../Hooks/usePageTitle';
import { showToast } from '../../../Components/Toast/Toast';
import useUserStore from '../../../Stores/UserStore';

import InnerBanner from '../../../Components/InnerBanner/InnerBanner';
import './ReferAFriend.css';
import referAFriendImage from '../../../assets/images/refer.png';
import CustomButton from '../../../Components/CustomButton';

const ReferAFriend = () => {
  usePageTitle('Refer a Friend');
  const { user } = useUserStore();
  
  // Get referral code from user object in localStorage
  const referralCode = user?.referral_code || '';

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode)
      .then(() => {
        showToast('Referral code copied to clipboard!', 'success');
      })
      .catch(() => {
        showToast('Failed to copy referral code', 'error');
      });
  };

  return (
    <>
      <InnerBanner heading="Refer a Friend" />
      <section className="py-sm-5 py-4">
        <Container>
          <Row>
            <Col xs={12} className="text-center">
              <p className="refer-description">
                Refer your friends and earn 100 coins for each person you refer who <br className="d-none d-md-block" /> 
                gets a paid subscription
              </p>
              <img 
                src={referAFriendImage} 
                alt="Refer a Friend" 
                className="refer-image img-fluid mx-auto mb-4" 
              />
              
              <div className="referral-code-container">
                <div className="referral-code-wrapper">
                  <label className="site-label ms-3">Referral Code</label>
                  <div className="referral-code-input-group">
                    <input 
                      type="text" 
                      value={referralCode} 
                      readOnly 
                      className="referral-code-input"
                    />
                    <CustomButton 
                      onClick={handleCopyCode}
                      className="py-2 px-4 fs-14 me-2 mnw-0"
                    >
                      Copy
                    </CustomButton>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ReferAFriend;
